import { ServicesGroup } from "utils/helpers/ServicesGroup"

export const serviceGroupId: Record<ServicesGroup["id"], "single" | "family"> = {
    1: "single",
    2: "family",
}
